var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.title)?_c('h1',{class:{ 'text-center': _vm.center }},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.subtitle)?_c('p',{class:{'subtitle mt-1 mb-2': true, 'text-center': _vm.center}},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),_c('div',{class:{ divider: _vm.divider, 'mt-5 mb-5': true }})])
}
var staticRenderFns = []

export { render, staticRenderFns }